import { BaseSseClient, type SseParsedEvent } from '@/stores/local/shared/BaseSseClient';

import { COMPLETE_EVENTS, DONE_EVENTS, ERROR_EVENTS, START_EVENTS, TOKEN_EVENTS } from './config';
import type { MeetingNotesErrorEventPayload, MeetingNotesSseHandlers } from './types';
import { isRecord, parseSummary } from './utils';

export class MeetingNotesSseClient extends BaseSseClient<MeetingNotesSseHandlers> {
  private _extractContent(event: SseParsedEvent): string {
    const { json, data } = event;

    return (
      this.pickString(json, 'label') ??
      this.pickString(json, 'content') ??
      this.pickString(json, 'text') ??
      this.pickString(json, 'data') ??
      data
    );
  }

  private _extractErrorMessage(event: SseParsedEvent): string {
    const { json, data } = event;
    const payload = isRecord(json) ? (json as MeetingNotesErrorEventPayload) : null;

    return payload?.message ?? payload?.error ?? payload?.detail ?? data ?? 'Ошибка при формировании саммари';
  }

  private _handleByEventName(
    eventName: string,
    event: SseParsedEvent,
    handlers: MeetingNotesSseHandlers,
    content: string,
  ): boolean {
    const { data, json } = event;

    if (eventName === 'comment' && data === 'ping') {
      handlers.onStart?.();

      return true;
    }

    if (START_EVENTS.has(eventName)) {
      handlers.onStart?.();

      return true;
    }

    if (TOKEN_EVENTS.has(eventName)) {
      handlers.onToken?.(content);

      return true;
    }

    if (COMPLETE_EVENTS.has(eventName)) {
      const summary = parseSummary(json);

      if (summary) {
        handlers.onComplete?.(summary);
      } else {
        handlers.onError?.('Некорректный формат complete-события');
      }

      return true;
    }

    if (ERROR_EVENTS.has(eventName)) {
      handlers.onError?.(this._extractErrorMessage(event));

      return true;
    }

    if (DONE_EVENTS.has(eventName)) {
      return true;
    }

    const statusText = content.trim();

    if (statusText.length > 0) {
      handlers.onStatus?.(statusText);
    }

    return true;
  }

  protected handleEvent(event: SseParsedEvent, handlers: MeetingNotesSseHandlers): void {
    const { eventName } = event;
    const content = this._extractContent(event);

    if (eventName && this._handleByEventName(eventName, event, handlers, content)) {
      return;
    }

    if (content.trim().length > 0) {
      handlers.onToken?.(content);
    }
  }
}
